import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '¿Qué es la tecnología OMR?',
      answer: 'OMR (Optical Mark Recognition) es una tecnología que permite leer y procesar marcas realizadas en papel, como las burbujas rellenadas en hojas de respuesta. Nuestro sistema escanea estas marcas y las convierte en datos digitales con una precisión del 99%.'
    },
    {
      question: '¿Cuánto tiempo toma procesar evaluaciones?',
      answer: 'El tiempo de procesamiento depende del volumen, pero generalmente entregamos resultados completos en menos de 24 horas. Para volúmenes pequeños (menos de 500 hojas), el procesamiento puede completarse en pocas horas.'
    },
    {
      question: '¿Qué formatos de reporte ofrecen?',
      answer: 'Generamos reportes en múltiples formatos: Excel con datos detallados para análisis, PDF con gráficos estadísticos, y reportes personalizados según las necesidades de tu institución. Incluimos análisis por pregunta, por estudiante y estadísticas generales.'
    },
    {
      question: '¿Cómo garantizan la confidencialidad?',
      answer: 'Implementamos protocolos de seguridad estrictos: encriptación de datos, acceso restringido, almacenamiento seguro y eliminación de información después del procesamiento. Firmamos acuerdos de confidencialidad con todas nuestras instituciones clientes.'
    },
    {
      question: '¿Pueden diseñar plantillas personalizadas?',
      answer: 'Sí, diseñamos plantillas OMR completamente personalizadas según tus necesidades: número de preguntas, opciones de respuesta, formato de identificación, y diseño visual. Nos adaptamos a cualquier tipo de evaluación.'
    },
    {
      question: '¿Qué volumen de evaluaciones pueden procesar?',
      answer: 'Podemos procesar desde pequeños grupos de 50 evaluaciones hasta grandes volúmenes de más de 10,000 hojas. Nuestra infraestructura tecnológica está preparada para manejar cualquier escala de proyecto.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#0D9488]/10 px-5 py-2 rounded-full mb-4">
            <i className="ri-question-line text-[#0D9488]"></i>
            <span className="text-[#0D9488] font-semibold text-sm">Resolvemos tus Dudas</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E] mb-4">
            Preguntas <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#D97706]">Frecuentes</span>
          </h2>
          <p className="text-base md:text-lg text-gray-500">
            Todo lo que necesitas saber sobre nuestros servicios
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all ${openIndex === index ? 'ring-2 ring-[#0D9488]/30' : ''}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 md:px-6 py-4 md:py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50/50 transition-colors"
              >
                <span className="text-base md:text-lg font-semibold text-[#1A1A2E] pr-4">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${openIndex === index ? 'bg-[#0D9488] rotate-180' : 'bg-gray-100'}`}>
                  <i className={`ri-arrow-down-s-line text-xl ${openIndex === index ? 'text-white' : 'text-gray-500'}`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-4 md:px-6 pb-4 md:pb-5 border-t border-[#0D9488]/10">
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}